import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db } from "../firebase";
import { doc, onSnapshot, deleteDoc } from "firebase/firestore";
import { FaBell } from "react-icons/fa";
import "./NotificationBell.css";

const NotificationBellStaff = () => {
  const [newAssignmentNotification, setNewAssignmentNotification] = useState(null);
  const [cancellationNotification, setCancellationNotification] = useState(null);
  const [completedNotification, setCompletedNotification] = useState(null);
  const [open, setOpen] = useState(false);
  const [nombreStaff, setNombreStaff] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const storedNombre = localStorage.getItem("nombre_get");
    if (!storedNombre) {
      console.log("No se encontró nombre_get en localStorage");
      return;
    }
    const normalizedNombre = storedNombre.trim().toLowerCase().replace(" ", "_");
    console.log("Nombre normalizado del staff:", normalizedNombre);
    setNombreStaff(normalizedNombre);

    // Escuchar notificaciones de nuevas asignaciones
    const assignmentSummaryRef = doc(db, `notifications/${normalizedNombre}/new_assignments/status`);
    console.log("Escuchando notificaciones de asignaciones en:", `notifications/${normalizedNombre}/new_assignments/status`);
    const unsubAssignment = onSnapshot(
      assignmentSummaryRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = { id: docSnapshot.id, ...docSnapshot.data() };
          console.log("Notificación de nuevas asignaciones recibida:", data);
          setNewAssignmentNotification(data);
        } else {
          console.log("No hay notificación de nuevas asignaciones activa");
          setNewAssignmentNotification(null);
        }
      },
      (error) => {
        console.error("Error al escuchar notificación de nuevas asignaciones:", error);
      }
    );

    // Escuchar notificaciones de cancelaciones
    const cancellationSummaryRef = doc(db, `notifications/${normalizedNombre}/cancellations/status`);
    console.log("Escuchando notificaciones de cancelaciones en:", `notifications/${normalizedNombre}/cancellations/status`);
    const unsubCancellation = onSnapshot(
      cancellationSummaryRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = { id: docSnapshot.id, ...docSnapshot.data() };
          console.log("Notificación de cancelaciones recibida:", data);
          setCancellationNotification(data);
        } else {
          console.log("No hay notificación de cancelaciones activa");
          setCancellationNotification(null);
        }
      },
      (error) => {
        console.error("Error al escuchar notificación de cancelaciones:", error);
      }
    );

    // Escuchar notificaciones de actividades completadas
    const completedSummaryRef = doc(db, `notifications/${normalizedNombre}/completed/status`);
    console.log("Escuchando notificaciones de actividades completadas en:", `notifications/${normalizedNombre}/completed/status`);
    const unsubCompleted = onSnapshot(
      completedSummaryRef,
      (docSnapshot) => {
        if (docSnapshot.exists()) {
          const data = { id: docSnapshot.id, ...docSnapshot.data() };
          console.log("Notificación de actividades completadas recibida para staff:", data);
          setCompletedNotification(data);
        } else {
          console.log("No hay notificación de actividades completadas activa para el staff");
          setCompletedNotification(null);
        }
      },
      (error) => {
        console.error("Error al escuchar notificación de actividades completadas:", error);
      }
    );

    return () => {
      unsubAssignment();
      unsubCancellation();
      unsubCompleted();
    };
  }, []);

  const handleGoToAssignments = () => {
    navigate('/MisAsignaciones');
    setOpen(false);
  };

  const handleViewCancellation = async () => {
    if (nombreStaff) {
      try {
        const cancellationRef = doc(db, `notifications/${nombreStaff}/cancellations/status`);
        await deleteDoc(cancellationRef);
        console.log("Notificación de cancelación eliminada para staff:", nombreStaff);
        setCancellationNotification(null); // Actualizar el estado localmente
      } catch (error) {
        console.error("Error al eliminar notificación de cancelación:", error);
      }
    }
    navigate('/ActividadesFinalizadasStaff');
    setOpen(false);
  };

  const handleViewCompleted = async () => {
    if (nombreStaff) {
      try {
        const completedRef = doc(db, `notifications/${nombreStaff}/completed/status`);
        await deleteDoc(completedRef);
        console.log("Notificación de actividades completadas eliminada para staff:", nombreStaff);
        setCompletedNotification(null); // Actualizar el estado localmente
      } catch (error) {
        console.error("Error al eliminar notificación de actividades completadas:", error);
      }
    }
    navigate('/Completadas_staff');
    setOpen(false);
  };

  const totalNotifications = (newAssignmentNotification?.count || 0) + (cancellationNotification?.count || 0) + (completedNotification?.count || 0);

  if (!nombreStaff) {
    return <div className="text-sm text-gray-600">Por favor, inicia sesión para ver notificaciones.</div>;
  }

  return (
    <div className="notification-bell-container">
      <div
        className="bell-icon"
        onClick={() => setOpen((prev) => !prev)}
      >
        <FaBell size={24} />
        {totalNotifications > 0 && (
          <span className="notification-count">{totalNotifications}</span>
        )}
      </div>

      {open && (
        <div className="notification-dropdown">
          {newAssignmentNotification || cancellationNotification || completedNotification ? (
            <>
              {newAssignmentNotification && (
                <div className="notification-item">
                  <p>{newAssignmentNotification.message}</p>
                  <button onClick={handleGoToAssignments}>Ir</button>
                </div>
              )}
              {cancellationNotification && (
                <div className="notification-item">
                  <p>{cancellationNotification.message}</p>
                  <button onClick={handleViewCancellation}>Ver</button>
                </div>
              )}
              {completedNotification && (
                <div className="notification-item">
                  <p>{completedNotification.message}</p>
                  <button onClick={handleViewCompleted}>Ver</button>
                </div>
              )}
            </>
          ) : (
            <p className="text-sm text-gray-600 p-4 text-center">
              No hay nuevas notificaciones
            </p>
          )}
        </div>
      )}
    </div>
  );
};

export default NotificationBellStaff;